import React from 'react';

import SysconfigContext from './SystemConfiguration/SystemContext';

const useSysconfig = () => {
  return React.useContext(SysconfigContext);
};

export { useSysconfig };
